var mp = mp || {};


// Toogle Menu
//-----------------------------------------------------------------
mp.MenuToggle = function() {
    var $toggleButton = $('.header__hamburger');
    var $drawerWraper = $('.header__navigation');

    if (!$toggleButton.length) {
        return;
    }

    // Topbar links (hidden on mobile) are added to the mobile menu
    var $topbarLinks = $('.header__topbar .nav__link');

    if ($topbarLinks.length) {
        var $secondary = $('<ul class="menu menu--secondary"></ul>');

        $topbarLinks.each(function() {
            $('<li class="menu__item"></li>')
                .append($(this).clone().attr('class', 'menu__link'))
                .appendTo($secondary);
        });

        $drawerWraper.append($secondary);
    }

    $toggleButton.attr({ role: 'button', tabindex: 0, 'aria-label': 'Izbornik', 'aria-expanded': 'false' });

    function toggle(open) {
        $drawerWraper.toggleClass('is_open', open);
        $toggleButton.toggleClass('is_open', open).attr('aria-expanded', open ? 'true' : 'false');
        $('.header').toggleClass('is_open', open);
        $('body').toggleClass('locked', open);
    }

    $toggleButton.on('click', function(e) {
        e.preventDefault();
        toggle(!$drawerWraper.hasClass('is_open'));
    });

    $toggleButton.on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle(!$drawerWraper.hasClass('is_open'));
        }
    });

    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $drawerWraper.hasClass('is_open')) {
            toggle(false);
        }
    });

    // Close when resized to desktop layout
    $(window).on('resize', function() {
        if (window.innerWidth >= 1024 && $drawerWraper.hasClass('is_open')) {
            toggle(false);
        }
    });
}



// Showing/hiding header on scroll
//-----------------------------------------------------------------
mp.stickyHeader = function() {

    var $header = $('.header'),
        headerHeight = $header.outerHeight(),
        lastScrollTop = 0,
        offset = 0,
        didScroll;

    if (!$header.length) {
        return;
    }

    $(window).scroll(function(event){
        didScroll = true;
    });

    var st = $(window).scrollTop();

    if (st > 0 ) {
        didScroll = true;
    }

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();

        if (Math.abs(lastScrollTop - st) <= offset) {
            return;
        } else {
            didScroll = true;
        }

        if (st > lastScrollTop && st > headerHeight){
            // Scroll down
            $header.removeClass('nav_down').addClass('nav_up');
        }
        else if (st + $(window).height() < $(document).height()) {
            // Scroll up
            $header.removeClass('nav_up').addClass('nav_down');
        }
        
        if ($(window).scrollTop() <= 100) {
            $header.removeClass('nav_down nav_up');
        }

        lastScrollTop = st;
    }

};


$(document).ready(function(){
    mp.MenuToggle();
    mp.stickyHeader();
    //mp.submenuToggle();
});